import {
  colors,
  space,
  typography,
  body,
  zIndex,
  breakpoints,
  global,
  radii,
  shadows,
} from './styles';
import * as components from './components';

export default {
  space,
  colors,
  typography,
  body,
  zIndex,
  breakpoints,
  global,
  radii,
  shadows,
  ...components,
};
